<template>
  <div class="zones mt-10">
    <v-container class="pb-0">
      <v-dialog v-model="mutationDialog" max-width="1000">
        <v-data-table style="padding: 15px; overflow: hidden;" :loading="loadingMutation"
          :headers="headersMutation" :items="recordsMutation" class="elevation-1 mt-0" :disable-sort="disableSort"
          :server-items-length="totalDataMutation" :items-per-page.sync="itemPerPageMutation"
          @update:page="getMutation(selectedZone)" @update:items-per-page="getMutation(selectedZone)"
          :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page')  }"
          :page="pageMutation"
          :no-data-text="$t('no_data')">
          <template v-slot:item.group_name="{ item }">
          <span style="color: #3277D5">{{ item.group_name }}</span>
        </template>
        <template v-slot:item.period_start="{ item }">
          {{ formatDate(item.period_start) }} - {{ formatDate(item.period_end) }}
        </template>
          <template v-slot:top>
            <h2 style="font-size: 24px; line-height: 36px;" class="pa-4">Work Mutation</h2>
            <v-row class="pa-4">
              <v-col md="4">
                <v-select :class="lang === 'id' ? 'set-zone2' : 'set-zone1'" :items="zones" placeholder="Pilih Zona" item-text="zonename" item-value="id"
                  v-model="selectedZone"></v-select>
              </v-col>
              <v-col md="3" class="pb-0">
                <v-menu ref="menu" v-model="menu_start" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="dateFormatted(start_date)" :label="$t('start_date')"
                      prepend-icon="mdi-calendar" readonly v-on="on" color="primary"></v-text-field>
                  </template>
                  <v-date-picker v-model="start_date" :locale="$t('locale')" no-title
                    scrollable></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="3" class="pb-0">
                <v-menu ref="menu" v-model="menu_end" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="dateFormatted(end_date)" :label="$t('end_date')" prepend-icon="mdi-calendar"
                      readonly v-on="on" color="primary"></v-text-field>
                  </template>
                  <v-date-picker v-model="end_date" :locale="$t('locale')" :min="start_date"
                    no-title scrollable>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" class="pt-6">
                <v-btn block color="primary" @click="getMutation(selectedZone)">
            <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
          </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-dialog>
      <v-dialog v-model="deleteDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{$t('delete')}}</v-card-title>
          <v-card-text>{{$t('you_sure')}}</v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="default" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
            <v-btn color="error" @click="sendDeleteItem()">{{$t('delete')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card class="px-6 pb-0 mb-3">
        <v-row>
          <v-col md="2">
            <h2>{{$t('zones')}}</h2>
          </v-col>
          <v-col md="3" class="mt-n4" offset="2">
            <v-text-field :rules="[validator.alfaNumberNotRequired]" :label="$t('find_a_zone')"
              prepend-inner-icon="mdi-magnify" single-line v-model="search_zones" @keyup.enter="fetchZones()">
            </v-text-field>
          </v-col>
          <v-col md="3">
            <v-btn block outlined color="primary">
              <v-icon>mdi-download</v-icon>
              <download-excel :data="zones_report" worksheet="Zones" :name="excelTitle">{{$t('download_report')}}
              </download-excel>
            </v-btn>
          </v-col>
          <v-col md="2">
            <v-dialog v-model="addDialog" max-width="600px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" block>{{$t('add_zones')}}</v-btn>
              </template>
              <v-card class="pt-3">
                <v-card-title>
                  <span class="headline ml-2">{{$t('add_zones')}}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="addForm" v-model="valid">
                      <v-row>
                        <GmapMap :center="{
                            lat: tempGeometry.geometry.location.lat,
                            lng: tempGeometry.geometry.location.lng
                          }" :zoom="12" map-type-id="terrain" style="width: 500px; height: 300px">
                          <Gmap-Marker v-if="addFormMarker" :position="{
                              lat: tempGeometry.geometry.location.lat,
                              lng: tempGeometry.geometry.location.lng
                            }"></Gmap-Marker>
                        </GmapMap>
                        <v-col cols="12" sm="12" md="12" class="mt-0">
                          <v-text-field :label="$t('office_name')" v-model="addItem.zonename"
                            :rules="[...rules, validator.zoneRequired]"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4">
                          <v-text-field :label="$t('latitude')" v-model="addItem.lat_zone" :rules="latRules">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field :label="$t('longitude')" v-model="addItem.lng_zone" :rules="lngRules">
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4">
                          <small>
                            <label>Cari Alamat</label>
                            <br />
                          </small>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="primary" :loading="loadingGetAddress"
                                @click="getAddress(addItem.lat_zone, addItem.lng_zone, 'add')">
                                <v-icon>mdi-magnify</v-icon>
                              </v-btn>
                            </template>
                            <span>Cari Alamat</span>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <label>
                            <!-- Auto Complete Mode -->
                            <!--   <div
                              class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                              <div class="v-input__control">
                                <div class="v-input__slot">
                                  <div class="v-text-field__slot">
                                    <label
                                      class="v-label v-label--active theme--light"
                                      style="left: 0px; right: auto; position: absolute;"
                                    >Alamat Kantor</label>
                                    <gmap-autocomplete
                                      placeholder
                                      class
                                      style="width: 100%;color:#333"
                                      @place_changed="setPlace"
                                      ref="gmap"
                                    ></gmap-autocomplete>
                                  </div>
                                </div>
                              </div>
                            </div>-->

                            <!-- Manual Mode -->
                            <v-text-field :label="$t('office_address')" v-model="addItem.address_zone"
                              :rules="[...rules, validator.zoneRequired]"></v-text-field>
                          </label>
                        </v-col>

                        <v-col cols="12" sm="4" md="6">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-bind="attrs" v-on="on" :label="$t('radius_in_meter')"
                                v-model="addItem.radius" :rules="[...rules, validator.numberNotRequired]">
                              </v-text-field>
                            </template>
                            <span>Batas area check-in/out untuk karyawan Anda</span>
                          </v-tooltip>
                        </v-col>
                        <!-- <v-col cols="12" sm="12" md="6">
                          <v-text-field
                            label="Company"
                            v-model="addItem.companyId"
                          ></v-text-field>
                        </v-col>-->
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions class="mx-6 pb-6">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
                  <v-btn color="primary" :disabled="!valid" :loading="loading" @click="addZoneMaster(addItem)">
                    {{$t('add')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card>
      <div class="mt-4">
        <GmapMap class="mt-3" :center="centerGmap" :zoom="zoomGmap" map-type-id="terrain" style="height: 300px">
          <GmapCluster>
            <GmapMarker :key="index" v-for="(m, index) in markers" :position="{ lat: m.lat_zone, lng: m.lng_zone }"
              :clickable="true" />
          </GmapCluster>
          <GmapCircle v-for="pin in markers" :key="pin.id" :center="{ lat: pin.lat_zone, lng: pin.lng_zone }"
            :radius="pin.radius" :visible="true" :options="{
            fillColor: 'red',
            fillOpacity: 0.07,
            strokeColor: '#FF0000',
            strokeOpacity: 0.2,
            strokeWeight: 2
          }"></GmapCircle>
        </GmapMap>
      </div>
    </v-container>

    <v-container class="pt-0">
      <v-data-table v-if="!firstLoad" :loading="loading" :headers="headers" :items="zones" class="elevation-1 mt-0"
        :disable-sort="disableSort" :server-items-length="totalData" :items-per-page.sync="itemPerPage"
        :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page')  }"
        :page="page" @update:page="fetchZones($event, itemPerPage)" @update:items-per-page="fetchZones(page, $event)"
        :no-data-text="$t('no_data')">
        <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
          {{ items.itemsLength }} </template>
        <template v-slot:top>
          <v-dialog v-model="dialog" max-width="600px">
            <v-card class="pt-3" :class="clas">
              <v-card-title>
                <span class="headline ml-2">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <GmapMap :center="{
                      lat: tempGeometry.geometry.location.lat,
                      lng: tempGeometry.geometry.location.lng
                    }" :zoom="12" map-type-id="terrain" style="width: 500px; height: 300px">
                    <Gmap-Marker v-if="editFormMarker" :position="{
                        lat: tempGeometry.geometry.location.lat,
                        lng: tempGeometry.geometry.location.lng
                      }"></Gmap-Marker>
                  </GmapMap>
                  <v-form ref="editForm" v-model="valid">
                    <v-row>
                      <v-col cols="12" sm="12" md="12" class="mt-3">
                        <v-text-field :label="$t('office_name')" v-model="editedItem.zonename"
                          :rules="[...rules, validator.zoneRequired]"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4">
                        <v-text-field :label="$t('latitude')" v-model="editedItem.lat_zone" :rules="latRules">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field :label="$t('longitude')" v-model="editedItem.lng_zone" :rules="lngRules">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-btn color="primary" :loading="loadingGetAddress"
                          @click="getAddress(editedItem.lat_zone, editedItem.lng_zone, 'edit')">
                          <v-icon>mdi-magnify</v-icon>Cari Alamat
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <!-- <v-text-field
                          label="Alamat Kantor"
                          v-model="editedItem.address_zone"
                        ></v-text-field>-->
                        <label>
                          <!-- <div
                            class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted"
                          >
                            <div class="v-input__control">
                              <div class="v-input__slot">
                                <div class="v-text-field__slot">
                                  <label
                                    class="v-label v-label--active theme--light"
                                    style="left: 0px; right: auto; position: absolute;"
                                  >Alamat Kantor</label>
                                  <gmap-autocomplete
                                    placeholder
                                    class
                                    style="width: 100%;color:#333"
                                    @place_changed="setPlaceEdit"
                                    ref="gmap"
                                  ></gmap-autocomplete>
                                </div>
                              </div>
                            </div>
                          </div>-->
                          <v-text-field :label="$t('office_address')" v-model="editedItem.address_zone"
                            :rules="[...rules, validator.zoneRequired]"></v-text-field>
                        </label>
                      </v-col>

                      <v-col cols="12" sm="4" md="4">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-bind="attrs" v-on="on" :label="$t('radius_in_meter')"
                              v-model="editedItem.radius" :rules="[...rules, validator.numberNotRequired]">
                            </v-text-field>
                          </template>
                          <span>Batas area check-in/out untuk karyawan Anda</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions class="mx-6 pb-6">
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close">{{ $t('cancel') }}</v-btn>
                <v-btn color="primary" :disabled="!valid" @click="saveToAPI(editedItem)" :loading="loading">
                  {{ $t('save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.zonename="{ item }">
          <b @click="zoomZone(item)" class="cursor text-primary">{{ item.zonename }}</b>
        </template>
        <!-- Table Edit & Delete Buttons -->
        <template v-slot:item.action="{ item }">
          <div class="row">
            <v-btn icon small class="mr-auto ml-auto" color="primary" @click="editItem(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn  v-if="company_id === 'pt-arya' || company_id === 'demo-appsensi' || company_id === 'pemkab-raja-ampat'" icon small class="mr-auto ml-auto" color="primary" @click="getMutation(item.id), selectedZone = item.id">
              <v-icon small>mdi-map-marker</v-icon>
            </v-btn>

            <v-btn icon small class="mr-auto ml-auto" color="error" @click="deleteItemConfirmation(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.address_zone="{ item }">{{item.address_zone | elipsis}}</template>

        <template v-slot:item.radius="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{item.radius}}</span>
            </template>
            <span>Batas area check-in/out untuk karyawan Anda</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="loading"></v-skeleton-loader>
    </v-container>
  </div>
</template>
<script>
 import moment from "moment";
  export default {
    name: "zones",
    data() {
      const lang = localStorage.getItem('lang') || 'id';
      return {
        excelTitle: `Zones ${this.$store.getters.companyDetail.name_company}.xls`,
        loadingGetAddress: false,
        addFormMarker: false,
        editFormMarker: false,
        zoomGmap: 12,
        start_date: "",
        end_date: "",
        menu_start: false,
        menu_end: false,
        centerGmap: {
          lat: -6.266202,
          lng: 106.818325
        },
        tempGeometry: {
          geometry: {
            location: {
              lat: -6.266202,
              lng: 106.818325
            }
          }
        },
        deleteItem: null,
        lang: lang,
        deleteDialog: false,
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        firstLoad: true,
        disableSort: true,
        totalData: 0,
        company_id: this.$store.state.company,
        page: 1,
        itemPerPage: 10,
        pageMutation: 1,
        itemPerPageMutation: 10,
        totalDataMutation: 0,
        errorMessage: '',
        latRules: [v => v >= -90 && v <= 90 || this.$i18n.t('required_90'), v => !!v || this.$i18n.t('required'), v =>
          /^[0-9\-.]+$/.test(v) || this.$i18n.t('latlong_required')
        ],
        lngRules: [v => v >= -180 && v <= 180 || this.$i18n.t('required_180'), v => !!v || this.$i18n.t('required'),
          v => /^[0-9\-.]+$/.test(v) || this.$i18n.t('latlong_required')
        ],
        rules: [(value) => (!!value || this.$i18n.t('required'))],
        zones: [{
          id: "",
          zonename: ""
        }],
        loading: true,
        loadingMutation: true,
        headers: [{
            text: this.$i18n.t('office_name'),
            value: "zonename",
            width: '20%'
          },
          {
            text: this.$i18n.t('office_address'),
            value: "address_zone",
            width: '35%'
          },
          {
            text: this.$i18n.t('latitude'),
            value: "lat_zone"
          },
          {
            text: this.$i18n.t('longitude'),
            value: "lng_zone"
          },
          {
            text: this.$i18n.t('radius_in_meter'),
            value: "radius"
          },
          {
            text: this.$i18n.t('action'),
            value: "action"
          }
        ],
        headersMutation: [{
            text: this.$i18n.t('employee_name'),
            value: "full_name",
          },
          {
            text: this.$i18n.t('group'),
            value: "group_name",
          },
          {
            text: 'Periode di lokasi ini',
            value: "period_start"
          },
          {
            text: 'Lokasi Sekarang',
            value: "current_location"
          }
        ],

        recordsMutation: [],
        addItem: {
          id: "",
          zonename: "",
          address_zone: "",
          lat_zone: "",
          lng_zone: "",
          radius: '0',
          companyId: ""
        },
        defaultItem: {
          id: "",
          zonename: "",
          address_zone: "",
          lat_zone: "",
          lng_zone: "",
          radius: '0',
          companyId: ""
        },
        editedItem: {
          id: "",
          zonename: "",
          radius: '0',
        },
        center: {
          lat: -6.1753924,
          lng: 106.8249641
        },
        zones_report: [],
        editedIndex: -1,
        search: "",
        dialog: false,
        addDialog: false,
        search_zones: "",
        markers: [],
        places: null,
        firstEdit: true,
        clas: 'opa',
        valid: null,
        mutationDialog: false,
        selectedZone: null
      };
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? this.$i18n.t('new_zone') : this.$i18n.t('edit_zone');
      }
    },
    methods: {
      formatDate(date) {
        if(date){
          const newDate = date/1000
          return moment.unix(newDate).format("DD MMM YYYY");
        }else{
          return this.$i18n.t('now')
        }
     
    },
      onStartDateChange() {
        const diff = moment(this.end_date).diff(this.start_date, 'days')
        if (diff < 0) this.end_date = this.start_date
        this.menu_start = false;
      },
      onEndDateChange() {
        this.menu_end = false;
      },
      dateFormatted(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
      },
      openMutation() {
        this.mutationDialog = true
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      zoomZone(item) {
        this.centerGmap.lat = item.lat_zone
        this.centerGmap.lng = item.lng_zone
        this.zoomGmap = 17
      },
      async getAddress(lat, lng, type) {
        if (lat && lng) {
          this.loadingGetAddress = true
          const result = await this.$store.dispatch('getAddressMaps', {
            latlng: `${lat},${lng}`,
            key: 'AIzaSyAdfU8LnR3fHg7oPVo_mSeUIFjI64Af3YI'
          })
          setTimeout(() => {
            this.loadingGetAddress = false
          }, 3000);

          if (result.results.length > 0) {
            this.tempGeometry = result.results[0]
            switch (type) {
              case 'add':
                this.addItem.address_zone = this.tempGeometry.formatted_address

                this.addFormMarker = true
                this.editFormMarker = false
                break;
              case 'edit':
                this.editedItem.address_zone = this.tempGeometry.formatted_address

                this.addFormMarker = false
                this.editFormMarker = true
                break;
            }
          }
        }
      },
      setPlace(places) {
        this.addItem.lat_zone = places.geometry.location.lat();
        this.addItem.lng_zone = places.geometry.location.lng();
        this.addItem.address_zone = places.formatted_address
        this.places = places;
        this.center = {
          lat: places.geometry.location.lat(),
          lng: places.geometry.location.lng(),
        }
      },
      setPlaceEdit(places) {
        this.editedItem.lat_zone = places.geometry.location.lat();
        this.editedItem.lng_zone = places.geometry.location.lng();
        this.editedItem.address_zone = places.formatted_address
        this.places = places;
        this.center = {
          lat: places.geometry.location.lat(),
          lng: places.geometry.location.lng(),
        }
      },
      usePlace() {
        if (this.places) {
          this.markers.push({
            position: {
              lat: this.places.geometry.location.lat(),
              lng: this.places.geometry.location.lng()
            }
          });
          this.places = null;
        }
      },
      stringToLatLng(lat, lng) {
        let coordinates = {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        };
        return coordinates;
      },
      updateCoordinates(location) {
        this.editedItem.lat_zone = location.latLng.lat();
        this.editedItem.lng_zone = location.latLng.lng();
      },
      editItem(item) {
        this.editedIndex = this.zones.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
        this.fetchZones();
        this.tempGeometry.geometry.location.lat = item.lat_zone
        this.tempGeometry.geometry.location.lng = item.lng_zone
        this.editFormMarker = true
        if (this.firstEdit) this.blinkDialog()
      },
      blinkDialog() {
        // function "Watch->dialog" not working on first time open
        setTimeout(() => {
          this.dialog = false
          this.firstEdit = false
          setTimeout(() => {
            this.clas = ''
            this.dialog = true
          }, 200);
        }, 200);
      },
      deleteItemConfirmation(item) {
        this.deleteItem = Object.assign({}, item);
        this.deleteDialog = true;
      },
      async sendDeleteItem() {
        this.loading = true
        const result = await this.$store.dispatch('deleteZoneMaster', {
          id: this.deleteItem.id
        })
        this.loading = false
        if (result) {
          this.deleteDialog = false;
          this.showMessage('success', this.$i18n.t('alert_delete'))
          this.fetchZones();
        }
      },
      latLngToString(item = '') {
        if (item) {
          return "'" + item.toString();
        } else {
          return "'"
        }
      },
      close() {
        this.dialog = false;
        this.addDialog = false;
      },
      async saveToAPI(item) {
        const body = {
          zoneName: item.zonename,
          addressZone: item.address_zone,
          latZone: item.lat_zone,
          lngZone: item.lng_zone,
          radius: item.radius,
          id: item.id
        }
        this.loading = true
        const result = await this.$store.dispatch('editZoneMaster', body)
        this.loading = false
        if (result) {
          this.dialog = false;
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.fetchZones();
          this.clearData()
        }
      },
      async addZoneMaster(item) {
        const company_id = this.$store.state.company;
        const body = {
          zoneName: item.zonename,
          addressZone: item.address_zone,
          latZone: item.lat_zone,
          lngZone: item.lng_zone,
          radius: item.radius,
          companyId: company_id
        }
        this.loading = true
        const result = await this.$store.dispatch('saveZoneMaster', body)
        this.loading = false
        if (result) {
          this.addDialog = false;
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.fetchZones();
          this.clearData()
        }
      },
      clearData() {
        this.addItem = {
          id: "",
          zonename: "",
          address_zone: "",
          lat_zone: "",
          lng_zone: "",
          radius: '0',
          companyId: ""
        }
        this.editedItem = {
          id: "",
          zonename: "",
          radius: '0',
        }
        this.places = null
      },
      async fetchZonesForDownload() {
        let companyId = this.$store.state.company;
        const result = await this.$store.dispatch('getZoneMasterByCompany', {
          companyId
        })
        this.zones_report = [];
        result.rows.map(row => {
          let reportZones = {};
          reportZones.ZoneName = row.zonename;
          reportZones.Address = row.address_zone;
          reportZones.Latitude = this.latLngToString(row.lat_zone);
          reportZones.Longtitude = this.latLngToString(row.lng_zone);
          reportZones.Radius = row.radius;

          this.zones_report.push(reportZones);
        })
      },
      async fetchZones(page = 1, itemPerPage = 25) {
        let company_id = this.$store.state.company;
        this.page = page;
        this.itemPerPage = itemPerPage;
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page - 1;
        this.loading = true
        const result = await this.$store.dispatch('getZoneMasterByCompany', {
          companyId: company_id,
          page: start,
          pageSize: totalPageSend,
          zoneName: this.search_zones
        })
        this.loading = false
        this.firstLoad = false
        this.totalData = result.count
        this.zones = result.rows
        this.markers = this.zones
      },
      async getMutation(item) {
        this.mutationDialog = true
        let company_id = this.$store.state.company;
        this.loadingMutation = true
        const result = await this.$store.dispatch('getMutationZones', {
          companyId: company_id,
          page:  this.pageMutation -1,
          pageSize: this.itemPerPageMutation,
          zoneId: item,
          startDate: this.start_date,
          endDate: this.end_date
        })
        this.loadingMutation = false
        this.recordsMutation = result.records
        this.totalDataMutation = result.total
          // eslint-disable-next-line no-console
      }
    },
    created() {
      this.fetchZones();
      this.fetchZonesForDownload()
      this.start_date = moment()
        .subtract(365 , "days")
        .format("YYYY-MM-DD");
      this.end_date = moment().format("YYYY-MM-DD");
    },
    watch: {
      dialog(show) {
        // if (this.$refs.editForm) {
        // this.$refs.editForm.reset()
        // }
        if (show) {
          if (this.$refs.gmap) {
            this.$refs.gmap.$el.value = this.editedItem.address_zone
          }
        }
      },
      async addDialog() {
        if (this.$refs.gmap) {
          this.$refs.gmap.$el.value = ''
        }
        if (this.$refs.addForm) {
          await this.$refs.addForm.reset()
          this.clearData()
        }
      }
    }
  };
</script>
<style scoped>
  .opa {
    opacity: 0 !important;
  }

  .cursor {
    cursor: pointer;
  }

  .text-primary {
    color: #033a6d !important;
  }

  .set-zone1::before {
    content: 'Pick Location';
    position: absolute;
    bottom: 55px;
    left: 0px;
    height: 10px;
    font-size: 12px;
    color: #898989;
  }
  .set-zone2::before {
    content: 'Pilih Lokasi';
    position: absolute;
    bottom: 55px;
    left: 0px;
    height: 10px;
    font-size: 12px;
    color: #898989;
  }
</style>